import { IThemeCreationOptions } from '@/contexts/styles/ThemeActionContext';
import { responsiveFontSizes } from '@mui/material/styles';

const DefaultAfterThemeCreated: IThemeCreationOptions['afterThemeCreated'] = (theme, chosenTheme, chosenThemeSize) => {
    return responsiveFontSizes(theme);
};

export default DefaultAfterThemeCreated;